module.exports = __webpack_public_path__ + "img/motor_no28.c0b76997.jpg";